import { useLanguageContext } from "../../../../context/LanguageContext";
import { RouteConfig } from "../../RouteConfig";
import { useAxisConfigsRouteValidator } from "../../../validators/integrations/axis/AxisConfigsRouteValidator";
import AxisConfigsPage from "../../../../pages/integrations/axis_configs/index/AxisConfigsPage";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useAxisConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/axis")
    .setLabel(translate("eva.main.entities.axis_config"))
    .setValidator(useAxisConfigsRouteValidator())
    .setPage(<AxisConfigsPage />);
}

export default useAxisConfigsRouteConfig;
